<template>
    <div class="toLo_tips" >
        <div class="toLo_tips_bg"></div>
        <div class="toLo_tips_content">
            <!-- <div class="toLo_tips_content-tit">
                您还未登录~<span @click="handleLogin">点击去登录</span>
                <div class="app-header__vip-close" @click="$emit('closeLoginModel',false)">
                    关闭
                </div>
            </div> -->
            <div class="toLo_tips_content-tit">
                {{msg ? msg : '请求失败，请返回刷新重试'}}<span @click="handleBack">返回上一页</span>
                <div class="app-header__vip-close" @click="$emit('closeLoginModel',false)">
                    关闭
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { navTo } from '../utils/utils'
	import router from '../router/index'
    export default {
        name: 'modelToLogin',
        props:['msg'],
        methods:{
            handleLogin(){
                navTo('/login')
            },
            handleBack(){
                router.go(-1)
            }
        }
    }
</script>
<style  scoped lang="scss">
    .toLo_tips{
        width: 100%;
        height: 100%;
        /*background: red;*/
        position:fixed;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;

    .toLo_tips_bg{
        width: 100%;
        height: 100%;
        /*background: red;*/
        position:absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.4);
    }
    .toLo_tips_content{
        background: #FFFFFF;
        position: relative;
        z-index: 20;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        &-tit{
            width: 600px;
            font-size: 20px;
            color: #333;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgba(203, 41, 69, 0.06);
            border-radius: 10px;
            padding: 30px 20px;
            span{
                cursor: pointer;
                color: #CB2945;
                margin: 0 10px;
                font-size: 24px;
            }
        }

    }
    .app-header__vip-close {
        position: absolute;
        top: 5px;
        right: 10px;
        cursor: pointer;
        font-size: 14px;
    }
    .app-header__vip-close img {
        width: 100%;
        height: 100%;
    }

}
</style>
